const produtos = [
	{
		id: 1,
		produto: 'EZ - Black',
		foto: require('assets/images/ez001.png'),
	},
	{
		id: 2,
		produto: 'EZ - Wood',
		foto: require('assets/images/ez002.png'),
	},
	{
		id: 3,
		produto: 'EZ - Yellow',
		foto: require('assets/images/ez003.png'),
	},
	{
		id: 4,
		produto: 'EZ - Acqua',
		foto: require('assets/images/ez004.png'),
	},
	{
		id: 5,
		produto: 'Echo-Dot - White',
		foto: require('assets/images/eco_dot_1.png'),
	},
	{
		id: 6,
		produto: 'Echo-Dot - Black',
		foto: require('assets/images/eco_dot_2.png'),
	},
	{
		id: 7,
		produto: 'Echo-Dot - Cyan',
		foto: require('assets/images/eco_dot_3.png'),
	},
	{
		id: 8,
		produto: 'Google Nest Audio',
		foto: require('assets/images/NEST.png'),
	},
	{
		id: 9,
		produto: 'Nest mini',
		foto: require('assets/images/NESTmini.png'),
	},
];

export default produtos;
